import {useQuery, useQueryClient} from '@tanstack/react-query';
import {MetadataQueryKey} from '../../context/MetadataContext';
import {useApiMutation} from './api';
import {
  CompleteOnboarding,
  UpdateWebsite,
} from '../../shared/api/definitions/customer';
import {useKeyplayApi} from '../../context/ApiContext';
import {WithId} from '../../shared/util';

export function useMembership({enabled = true}: {enabled?: boolean} = {}) {
  const makeApiCall = useKeyplayApi();

  return useQuery({
    queryKey: ['customer', 'memberships'],
    queryFn: () =>
      makeApiCall<WithId<{name: string}>[]>('/customer/membership'),
    enabled,
  });
}

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();
  return useApiMutation(CompleteOnboarding, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}

export function useUpdateWebsite() {
  const queryClient = useQueryClient();
  return useApiMutation(UpdateWebsite, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
}
